import getWithToken from './base/get-with-token'

const getGroupAvailableCustomers = (id, params = {}) =>
  getWithToken(`/customer/${id}/group/available-customers`)(params)

export default getGroupAvailableCustomers
